import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { IVehicle } from '../../../schema/Vehicle.ts';
import { useRoadmap } from '../../../services/Roadmap.ts';
import { getOccupiedSeatsCount } from '../../../utils/fleetUtils.ts';

export function OccupiedSeats({ vehicle }: Readonly<{ vehicle: IVehicle }>) {
  const { territorySlug } = useParams() as { territorySlug: string };
  const { data: roadmapData } = useRoadmap(
    territorySlug,
    vehicle?.id,
    vehicle?.shuttle_provider_identifier,
  );

  const countOccupiedSeats = useMemo(() => {
    if (roadmapData) {
      return getOccupiedSeatsCount(roadmapData);
    }
    return undefined;
  }, [roadmapData]);

  return (
    <>
      {countOccupiedSeats !== undefined && (
        <div className="d-flex align-items-center">
          <img src="/theme/media/occupied-seat.svg" height="15" className="me-1" alt="Occupied seats" />
          <p className="text-basic my-auto">{countOccupiedSeats}</p>
        </div>
      )}
    </>
  );
}
